import React from 'react';
import { useState, useEffect } from 'react';
import { useCallback } from 'react';

import { AllCommunityModule, ModuleRegistry } from 'ag-grid-community'; 
import { AgGridReact } from 'ag-grid-react'; // React Data Grid Component
import { useTableData } from './hooks/useTableData';
import { AG_GRID_LOCALE_RU } from '../common/AgGrid/locale.ru';


ModuleRegistry.registerModules([AllCommunityModule]);


function TableTab ({schema, data, setSchema, setData, setIsDirty}) {
  


  const [tableData, setTableData] = useState([]);
  //const [error, setError] = useState(false)

  const [colDefs, setColDefs] = useState([
      // имя поля можно редактировать только одновременно с uiSchema
      { field: "name", width: "250", editable: false },
      { field: "type" },
      { field: "minimum", width: "120", editable: true},
      { field: "maximum", width: "120", editable: true},
      { field: "decimal_places", width: "120", headerName: 'Точность', editable: true},
      { field: "maxLength", width: "250", headerName: 'Максимальная длина строки', editable: true},
      { field: "analyte_number", width: "160", headerName: 'Номер аналита', editable: true, cellDataType: 'number'},
  ]);

  const { loadTableData, generateSchemafromTable } = useTableData()

  // Загружаем данные при изменении schema или data
  useEffect(() => {
    if (schema && data) {
      const initialTableData = loadTableData(schema, data);
      console.log('Загруженные данные таблицы:', initialTableData);
      setTableData(initialTableData);
    }
  }, [schema, data, loadTableData]);



  
  const updateSchema = useCallback((schema, tableData) => {

    setIsDirty(true)
    
    const newSchema = generateSchemafromTable(schema, tableData)
    
    setSchema(newSchema)
    //setData(newData)

    console.log('schema updated')
    console.log(newSchema)
    //alert(1)

  }, [generateSchemafromTable, setSchema, setData ])


  return (
    <div className="m-0 p-0"  >
      <div className="" style={{ height: "80vh", width: "100%" }}>
        <AgGridReact
          rowData={tableData}
          columnDefs={colDefs}
          defaultColDef={{
            sortable: true,
            filter: true,
            resizable: true
          }}
          localeText={AG_GRID_LOCALE_RU}
          onCellValueChanged={()=> updateSchema(schema, tableData)}
          suppressScrollOnNewData={true}
        />
      </div>
    </div>
  )
}


export default TableTab